import { useState, useEffect, useCallback } from 'react';
import { ChatHistoryDto } from '../../api/models';
import { useAuth } from 'react-oidc-context';
import { useAppSelector } from '../../redux/app/hooks';
import { RootState } from '../../redux/app/store';
import { ChatService } from '../services/ChatService';
import { useMemo } from 'react';

export const useChatHistory = () => {
    const [history, setHistory] = useState<ChatHistoryDto[]>([]);
    const [error, setError] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(true);

    const auth = useAuth();
    const { isAuthenticated, user } = auth;
    const token = user?.access_token;
    const hostContextState = useAppSelector((state: RootState) => state.hostContext.hostContext);

    const chatService = useMemo(() => {
        if (!isAuthenticated || !token) return null;
        return new ChatService(token);
    }, [isAuthenticated, token]);

    const fetchHistory = useCallback(async () => {
        if (!chatService) return;

        try {
            setIsLoading(true);
            const data = await chatService.getChatHistoryAsync(hostContextState);
            setHistory(data);
        } catch (error) {
            console.error('Failed to fetch chat history:', error);
            setError(error instanceof Error ? error.message : 'Failed to fetch chat history');
        } finally {
            setIsLoading(false);
        }
    }, [chatService, hostContextState]);

    useEffect(() => {
        void fetchHistory();
    }, [fetchHistory]);

    return { history, error, isLoading, refetch: fetchHistory };
};
